// Prospect demos: a real competition rebuilt for one sales conversation and
// shared through one link, for example demo.esports.statharbour.com/ebl-mfvwgs.
//
// Kept apart from ESPORTS_DEMO_LEAGUES (src/config/esportsDemo.ts) on purpose:
// those are the public title demos behind the switcher, while a prospect demo
// is unlisted (esports_leagues.is_listed = false), noindex everywhere it
// renders, and carries a "prepared for" ribbon. The slug is hard to guess but
// ships in the JavaScript bundle, so it is obscurity, not access control: the
// league is public to anyone holding the link, like any published league.
//
// The league id must match scripts/ebl-demo/lib/ids.mjs (EBL_LEAGUE_ID).

export interface EsportsProspectDemo {
  /** One path segment on the esports hosts, e.g. "ebl-mfvwgs". */
  slug: string;
  leagueId: string;
  /** Who the preview was built for, shown on the ribbon. */
  preparedFor: string;
  /** Show the "Preview prepared for ..." ribbon on the public pages. */
  ribbon: boolean;
}

export const ESPORTS_PROSPECT_DEMOS: readonly EsportsProspectDemo[] = [
  {
    slug: "ebl-mfvwgs",
    leagueId: "0eb10000-0000-4000-a000-0000000000f1",
    preparedFor: "Fortuna Esports",
    ribbon: true,
  },
];

export function getProspectDemoBySlug(slug: string | null | undefined): EsportsProspectDemo | undefined {
  if (!slug) return undefined;
  return ESPORTS_PROSPECT_DEMOS.find((d) => d.slug === slug);
}

export function getProspectDemoByLeagueId(leagueId: string | null | undefined): EsportsProspectDemo | undefined {
  if (!leagueId) return undefined;
  return ESPORTS_PROSPECT_DEMOS.find((d) => d.leagueId === leagueId);
}

/** The public hub a prospect link opens (the hub picks the active season). */
export const prospectDemoHubPath = (demo: EsportsProspectDemo): string => `/esports/public/${demo.leagueId}`;
